import React from 'react';

import { LandingQuote } from 'components/Quote';

export interface QuoteProps {
  node: {
    quote: {
      fieldQuote: string;
      fieldQuoteAuthor?: string;
      fieldQuotePosition?: string;
      quoteLink?: string;
      quoteLinkDescription?: string;
    };
  };
}

export const QuoteParagraph = ({ node }: QuoteProps) => {
  return <div className="blog-portfolio-quote">{node.quote && <LandingQuote quote={node.quote} />}</div>;
};
